import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetQueryParams } from '@/hooks/queryParams/useGetQueryParams';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { openLoginModal } from '@/redux/modules/modal';

/**
 * This is an empty page that opens a login modal
 *
 * After the user authenticates, the app will redirect to the `redirectTo` query param.
 *
 * The purpose of this page and it's redirect is to reliably run the redirecting page's loadData function
 */
const LoginRedirectPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { redirectTo } = useGetQueryParams()();
    const userIsLoggedIn = useAppSelector(isUserLoggedIn);

    React.useEffect(() => {
        // return to homepage if redirectTo query param is missing
        if (!redirectTo) {
            navigate('/');
        }

        // open login modal if user is not logged in
        if (!userIsLoggedIn) {
            dispatch(openLoginModal());
        } else {
            // return to redirectTo url after successful login
            navigate(redirectTo);
        }
    }, [redirectTo, userIsLoggedIn, navigate, dispatch]);

    return null;
};

export default LoginRedirectPage;
